import { OrderFormPayloadBaseSchema, OrderFormPayloadBaseType } from './OrderForm';

export type UpsellEventType = 'UpsellImpression' | 'UpsellClicked';

export type UpsellEventTypePayloadMap = {
  UpsellImpression: OrderFormPayloadBaseType;
  UpsellClicked: OrderFormPayloadBaseType;
};

export const UpsellEventSchemaMap = {
  UpsellImpression: OrderFormPayloadBaseSchema,
  UpsellClicked: OrderFormPayloadBaseSchema,
};
